import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { get } from ".././../utils/request";
import { actions as userActions } from "../../redux/modules/user";
import "./style.css";
class TabBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markArray: [1, 0, 0, 0, 0],
      userState: "我的",
      userLink: "/my",
      loginVisible: false,
      visible: true,
    };
  }
  componentDidMount() {
    this.requestUserInfo();
  }
  render() {
    const { uiState } = this.props;
    return (
      <div
        style={this.state.visible ? { display: "block" } : { display: "none" }}
        className="tabBar_box"
      >
        <NavLink
          onClick={() => this.activateTab(0)}
          className={
            this.state.markArray[0] ? "tabBar_nav_active fl" : "tabBar_nav fl"
          }
          to="/"
        >
          <div className="tabBar_nav_img">
            <img
              alt="主页"
              src={
                this.state.markArray[0]
                  ? require("../../images/TabBar/home_active.png")
                  : require("../../images/TabBar/home.png")
              }
            ></img>
          </div>
          <div>主页</div>
        </NavLink>
        <NavLink
          onClick={() => this.activateTab(1)}
          className={
            this.state.markArray[1] ? "tabBar_nav_active fl" : "tabBar_nav fl"
          }
          to="/school"
        >
          <div className="tabBar_nav_img">
            <img
              alt="神奇大学"
              src={
                this.state.markArray[1]
                  ? require("../../images/TabBar/school_active.png")
                  : require("../../images/TabBar/school.png")
              }
            ></img>
          </div>
          <div>神奇大学</div>
        </NavLink>
        <NavLink
          onClick={() => this.activateTab(2)}
          className={
            this.state.markArray[2] ? "tabBar_nav_active fl" : "tabBar_nav fl"
          }
          to={uiState.dayUpLink}
        >
          <div className="tabBar_nav_img">
            <img
              className="tabBar_nav_special_img"
              alt="每日高升"
              src={require("../../images/TabBar/newicon.gif")}
            ></img>
          </div>
          <div>每日高升</div>
        </NavLink>
        <NavLink
          onClick={() => this.activateTab(3)}
          className={
            this.state.markArray[3] ? "tabBar_nav_active fl" : "tabBar_nav fl"
          }
          to="/major"
        >
          <div className="tabBar_nav_img">
            <img
              alt="专业大全"
              src={
                this.state.markArray[3]
                  ? require("../../images/TabBar/major_active.png")
                  : require("../../images/TabBar/major.png")
              }
            ></img>
          </div>
          <div>专业大全</div>
        </NavLink>
        <NavLink
          onClick={(e) => this.activateTab(4)}
          className={
            this.state.markArray[4] ? "tabBar_nav_active fl" : "tabBar_nav fl"
          }
          to={uiState.userLink}
        >
          <div className="tabBar_nav_img">
            <img
              alt="我的"
              src={
                uiState.userState === "未登录"
                  ? require("../../images/TabBar/noLogin.png")
                  : this.state.markArray[4]
                  ? require("../../images/TabBar/my_active.png")
                  : require("../../images/TabBar/my.png")
              }
            ></img>
          </div>
          <div>{uiState.userState}</div>
        </NavLink>
        <div className="clear"></div>
      </div>
    );
  }
  /**
   * 请求用户信息
   */
  requestUserInfo = () => {
    const { dispatch } = this.props;
    let userInfo = {
      phone: "",
      year: "",
      isActive: false,
      isLogin: false,
    };
    get("/public/v1/user/info").then((res) => {
      if (
        res.status === "fail" &&
        (res.data.err_code === 20003 ||
          res.data.err_code === 20013 ||
          res.data.err_code === 10002)
      ) {
        this.setState({
          userState: "未登录",
          userLink: "/",
        });
        userInfo = {
          phone: "",
          year: "",
          isActive: false,
          isLogin: false,
          isBuy: false,
          discounts: 0,
          isWhiteUser: false
        };
        dispatch(userActions.setUserInfo(userInfo));
        dispatch(userActions.setUserState("未登录"));
        dispatch(userActions.setUserLink("/"));
      } else {
        userInfo = {
          phone: res.data.phone,
          year: res.data.year,
          isActive: res.data.isActive,
          isLogin: true,
          isBuy: res.data.isBuy,
          discounts: res.data.discounts,
          isWhiteUser: res.data.isWhiteUser,
        };
        dispatch(userActions.setUserInfo(userInfo));
        dispatch(userActions.setShowLogin(false));
        if (res.data.isBuy === true) {
          dispatch(userActions.setUserDayUpLink("/dayup"));
        }
      }
    });
  };
  activateTab = (id) => {
    const { dispatch } = this.props;
    if (id === 4 && this.props.uiState.userState === "未登录") {
      dispatch(userActions.setShowLogin(true));
    } else {
      dispatch(userActions.setShowLogin(false));
    }
    let tmpMarkArray = [0, 0, 0, 0, 0];
    tmpMarkArray[id] = 1;
    this.setState({ markArray: tmpMarkArray });
  };
}
const mapStateToProps = (state) => {
  return {
    uiState: state.user.uiStateData,
  };
};

export default connect(mapStateToProps)(TabBar);



// WEBPACK FOOTER //
// ./src/components/TabBar/index.js